import { useState } from "react"

import { useTranslation } from "react-i18next"

import { Modal } from "./Modal"

interface Props {
  data: any
  handler: () => void
  text: string
  actionText: string
  actionHandler: (data: any, notes: string) => Promise<void>
  placeholder?: string
  loading?: boolean
}

export const ModalNotesAction = ({ data, handler, text, actionText, actionHandler, placeholder, loading }: Props) => {
  const { t } = useTranslation("landing", { useSuspense: false })
  const [notes, setNotes] = useState("")

  const handleSubmit = async () => {
    await actionHandler(data, notes)
    setNotes("")
  }

  return (
    <Modal open={!!data} handler={handler}>
      <div className="relative flex flex-col justify-between modal-box">
        {text && <p className="pb-4">{text}</p>}
        <textarea
          className="textarea textarea-bordered w-full"
          rows={3}
          placeholder={placeholder}
          value={notes}
          onChange={(e) => setNotes(e.target.value)}
        />
        <div className="modal-action">
          <button className="btn btn-secondary" onClick={handler} type="button">
            {t("cancel")}
          </button>
          <button className="btn btn-primary" onClick={handleSubmit} disabled={loading}>
            {loading ? <span className="loading loading-spinner loading-xs" /> : actionText}
          </button>
        </div>
      </div>
    </Modal>
  )
}
